import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-fill-background',
    templateUrl: './fill-background.component.html',
    styleUrls: ['./fill-background.component.scss'],
    imports: [CommonModule, NgOptimizedImage],
})
export class FillBackgroundComponent implements OnInit {
    public selectedImage = '';
    @Input() images: string[] = [];
    @Input() shadow = true;
    @Input() alt = 'Facility background image';

    ngOnInit(): void {
        this.setRandomImage();
    }

    setRandomImage(): void {
        if (this.images.length) {
            const randomImage = Math.floor(Math.random() * this.images.length);

            this.selectedImage = this.images[randomImage];
        }
    }
}
